// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__2q9tz","Logo":"Navbar_Logo__2iG0s"};